angular.module('clientDashboardApp').directive('newComment', function ($rootScope) {
  return {
    restrict: 'A',
    template: `
  <i class='fas fa-pencil new-note-icon clickable' 
        ng-click='newNote()' 
        uib-tooltip="Add Note"
        >
  </i>
  `,
    scope: {
      entityId: '=',
      settings: '='
    },
    controller: function ($scope) {
      const entityId = $scope.entityId
      $scope.newNote = () => $rootScope.$broadcast('newCommentFor', {entityId})
    }
  }
})


